import { Injectable } from '@angular/core';
import { FiltersAbstractService } from 'src/app/common-page-components/classes/filters-abstract-service';

@Injectable({
  providedIn: 'root'
})
export class FiltersAthleteBiographyService extends FiltersAbstractService {
  constructor() {
    super();
  }

  /**
   * Method not required in this case, but it's abstract and must be implemented
   *
   * @memberof FiltersAthleteBiographyService
   */
  generateDefaultValues(): void {
    throw new Error("Method not implemented.");
  }

  /**
   * Method not required in this case, but it's abstract and must be implemented
   *
   * @memberof FiltersAthleteBiographyService
   */
  getDataStreamWithFilters(): import("rxjs").Observable<any> {
    throw new Error("Method not implemented.");
  }

}
